/** Serialise manage list query args for GET (booleans as "true"|"false"; omit empty). */
export function buildManageQueryParams(
  params: Record<string, unknown>
): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    if (typeof value === 'boolean') {
      out[key] = value ? 'true' : 'false';
    } else {
      out[key] = value as string | number;
    }
  }
  return out;
}
